import { createMutation } from '@amzn/gsce-shared-react-lib';
import {
  UploadMediaCommand,
  type UploadMediaCommandInput,
} from '@amzn/gbsa-helios-typescript-client';
import { apiHeliosClient } from 'src/data/api/apiHeliosClient';

/**
 * Mutation hook for uploading a media file (POST /media).
 *
 * Build the input from a browser File with fileToUploadMediaInput.
 * Deliberately NOT retried: uploads are not idempotent — a retry after an
 * ambiguous failure could create duplicate media objects.
 */
export const useUploadMediaMutation = createMutation((input: UploadMediaCommandInput) =>
  apiHeliosClient.send(new UploadMediaCommand(input)),
);
